import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * fileチェッククラス
 */
export default class EFOcats_validate_file extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    if (checkData.attr('type') !== 'file') {
      return new EFOcats_error_info('success', '', '', '');
    }

    let result = new EFOcats_error_info('success', '', '', '');

    const file = checkData.context.files[0].size;
    const file_limite = this.$('body').data('file_upload_limit') * 1048576;

    if (file > file_limite) {
      result = new EFOcats_error_info('error', this.langagerList('未選択エラー'), '', 'サイズエラー');
    }

    return result;
  }
}
